import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=0070958c&scoped=true&"
import script from "./Container.vue?vue&type=script&lang=ts&"
export * from "./Container.vue?vue&type=script&lang=ts&"
import style0 from "./Container.less?vue&type=style&index=0&id=0070958c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070958c",
  null
  
)

export default component.exports